import React, { useEffect } from "react";
import { Button, Form, Space, Input, InputNumber } from "antd";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { SettingInterface } from "src/store/community/settingsSlice";

interface propsInterface {
  onFinish: Function;
  params?: SettingInterface['data'] | undefined;
}

const _Purchase = ({ onFinish, params }: propsInterface) => {
  const [form] = Form.useForm();
  const paramsAsArray = paramsToArr(params);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  function onSubmit(values: any) {
    const preparedValues = { ...params, ...{ purchase: {} } };

    values.purchase_array.reverse().forEach((item: any) => {
      preparedValues['purchase'][item.key] = item.value;
    });

    onFinish(preparedValues);
  }

  function paramsToArr(params: any) {
    const arr: any = [];

    for (const key in params['purchase']) {
      arr.unshift({ key: key, value: params['purchase'][key] });
    }

    return { purchase_array: arr };
  }

  const ActionField = ({ name, remove, restField }) => {
    const key = paramsAsArray['purchase_array'][name]?.key;

    return (
      <Space style={{ display: 'flex', marginBottom: 2 }} align="baseline">
        <Form.Item
          {...restField}
          name={[name, 'key']}
          rules={[{ required: true, message: 'Missing action' }]}
        >
          <Input placeholder="action" disabled={key === 'default'} />
        </Form.Item>

        <Form.Item
          {...restField}
          name={[name, 'value']}
          rules={[{ required: true, message: 'Missing value' }]}
        >
          <InputNumber
            min={0}
            step={1}
            placeholder="5"
          />
        </Form.Item>

        {key !== 'default' && <MinusCircleOutlined onClick={() => remove(name)} />}
      </Space>
    );
  }

  return (
    <Form
      form={form}
      onFinish={values => onSubmit(values)}
      className='v-form'
      autoComplete="off"
      initialValues={paramsAsArray}
    >
      <Form.List name="purchase_array">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
                <ActionField
                  key={key}
                  name={name}
                  remove={remove}
                  restField={restField}
                />
              )
            )}

            <Form.Item>
              <Button
                type="dashed"
                onClick={add}
                block
                icon={<PlusOutlined />}
              >
                Add action
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Apply
        </Button>
      </Form.Item>
    </Form>
  );
}

export default _Purchase;
